import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IcosRadioGroup } from './radio-group'
import { IcosRadioButton } from './radio-button'
import { IcosRadio } from './radio'


@NgModule({
  declarations: [IcosRadio, IcosRadioGroup, IcosRadioButton],
  exports: [IcosRadio, IcosRadioGroup, IcosRadioButton],
  imports: [CommonModule, FormsModule],
  entryComponents: [IcosRadio, IcosRadioGroup, IcosRadioButton],
})
export class IcosRadiosModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosRadiosModule, providers: [] }
  }
}
